export const environment = {
    production: true,
    //URL_BASE_APP_USUARIOS: 'sbnserver.northeurope.cloudapp.azure.com:8890',
    URL_BASE_APP_USUARIOS: 'https://pre-appusuario.sicoralarmas.com:8085',
    URL_HOST: 'http://azuresbnweb.ibsiberia.com:3001/v1/api/',
    URL_DEEPLINK: "pre-areaclientes.sicoralarmas.com/app",
    USER_MANUAL_AJAX: "https://pre-areaclientes.sicoralarmas.com/files/Ajax.pdf",
    USER_MANUAL_HIK: "https://pre-areaclientes.sicoralarmas.com/files/Hikvision.pdf",
    MANUAL_APP: "https://pre-areaclientes.sicoralarmas.com/files/App.pdf",
    ENVIRONMENT_SELECTED: "D",
    APP_VERSION: "1.3.3.173",
    END_POINT_SBN: 'https://pre-appusuario.sicoralarmas.com:8085',
    FIREBASE_CONFIG: {
      apiKey: "AIzaSyCdrO1RSI0RyvEjJMJc1VU1eP-QpT8pHio",
      authDomain: "sicor-9d1c0.firebaseapp.com",
      projectId: "sicor-9d1c0",
      storageBucket: "sicor-9d1c0.appspot.com",
      messagingSenderId: "474765113922",
      appId: "1:474765113922:web:dff436e9dfc56c066c0bdb",
      measurementId: "G-EGF5P2VGE8"
    },
    KEY_CRYPTO: 'Sicor2022.',
    VAELSYS_CONFIG: {
      apiUrl: 'https://pre-vs.sicoralarmas.com/sbn/api/sbn',
      wsUrl: 'wss://pre-vs.sicoralarmas.com/ws/',
      wsRealm: 'default_realm',
      iceServers:[
        {
          url: 'turn:pre-vswebrtc.sicoralarmas.com:3478?transport=udp'
        },
        {
          url: 'turn:pre-vswebrtc.sicoralarmas.com:3478?transport=tcp',
        }
      ]
    },
    RECAPTCHA_V3_KEY: '6LefE2QqAAAAAKRxAVqmp-erSukhwzX3F3XqWlz1'
  };